"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.creerTraducteur = void 0;
/**
 * Point d'entrée « partage » — `@qanbio/i18n/partage`.
 *
 * Même `creerTraducteur` que la racine, construit sur les seuls espaces de noms
 * de cette surface (commun, partage). L'application importe ses valeurs d'ici,
 * jamais de `@qanbio/i18n` : la racine embarque le catalogue complet.
 */
const commun_1 = require("../catalogues/commun");
const partage_1 = require("../catalogues/partage");
const fabrique_1 = require("../fabrique");
__exportStar(require("./commun"), exports);
exports.creerTraducteur = (0, fabrique_1.creerFabriqueTraducteur)({
    fr: { ...commun_1.FR_COMMUN, ...partage_1.FR_PARTAGE },
    en: { ...commun_1.EN_COMMUN, ...partage_1.EN_PARTAGE },
});
//# sourceMappingURL=partage.js.map